export * from './screens/offers';
export * from './screens/client';

import * as apis from './backend/http';
export const http = {
  ...apis,
};
